/* eslint-disable @typescript-eslint/no-unused-vars */
import type { LinkBaseProps, LinkTypeMap } from '@mui/material'
import { Link as MaterialLink } from '@mui/material'
import type { OverridableComponent } from '@mui/material/OverridableComponent'
import type { To } from 'history'
import React from 'react'
import type { LinkProps } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import { appendProjectId } from 'utilities/use-navigate-project'

type MaterialUiProps = Omit<LinkBaseProps, 'href' | 'color'> & { external: true; href: string }

type ReactRouterProps = Omit<LinkProps, 'color' | 'to'> &
  ({ to: To } | { external: false | undefined; to: To })

type Props = MaterialUiProps | ReactRouterProps

/**
 * Link based on `react-router-dom/Link` with the look of `@material-ui/core/Link`
 *
 * Set `external` prop to `true` to use `@material-ui/core/Link` `href` property instead of default `react-router-dom/Link` `to`
 * @param {bool} props.external If set to `true`, will navigate without `@material-ui/core/Link`
 */
const LinkDefaultView = (props: React.PropsWithChildren<Props>) => {
  // If no external porp were provided, we render a
  // RouteLink component with the 'to' property
  if (!('external' in props)) {
    const { to, ...rest } = props
    return <BaseLink component={RouterLink} to={appendProjectId(to)} {...rest} />
  }

  // If external porp were provided and set to false,
  // we render a RouteLink component with the 'to' property
  if (!props.external) {
    const { external, to, ...rest } = props
    return <BaseLink component={RouterLink} to={appendProjectId(to)} {...rest} />
  }

  // If external porp were provided and set to true,
  // we render a MaterialLink component with provided properties
  const { external, ...rest } = props
  return <BaseLink {...rest} />
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BaseLink: OverridableComponent<LinkTypeMap> = (props: any) => {
  return <MaterialLink color="primary" className="bold" variant="body2" {...props} />
}

export default LinkDefaultView
